import { create } from 'zustand'
import { SendingScheduleEntity } from '../../domain/entities/SendingSchedule'
import { useCases } from '../../infrastructure/di/container'
import { Pagination } from '../types/Pagination'

type State = {
  items: SendingScheduleEntity[]
  pagination: Pagination
  isLoading: boolean
  error: string | null
}

type Actions = {
  fetch: (params: { page: number; perPage: number; search?: string }) => Promise<void>
  create: (payload: any) => Promise<any>
  append: (next: { items: SendingScheduleEntity[]; pagination: Pagination }) => void
  reset: () => void
}

const initialPagination: Pagination = { page: 1, perPage: 12, total: 0 }

export const useSendingSchedulesStore = create<State & Actions>((set, get) => ({
  items: [],
  pagination: initialPagination,
  isLoading: false,
  error: null,
  async fetch(params) {
    set({ isLoading: true, error: null })
    try {
      const res = await useCases.listSendingSchedules().execute(params)
      set({ items: res.items, pagination: { page: res.page, perPage: res.perPage, total: res.total }, isLoading: false })
    } catch (e: any) {
      set({ isLoading: false, error: e?.message || 'Failed to load sending schedules' })
    }
  },
  async create(payload) {
    const created = await useCases.createSendingSchedule().execute(payload)
    return created
  },
  append(next) {
    set({ items: [...get().items, ...next.items], pagination: next.pagination })
  },
  reset() { set({ items: [], pagination: initialPagination, isLoading: false, error: null }) }
}))
